// extracted by mini-css-extract-plugin
export default {"iconWithBg":"IconWithBg_iconWithBg__Pmohi"};